import { NotificationModel } from '@arpeggi/shared'
import { FC } from 'react'
import {
  ActivityFavoritedNotification,
  ActivityMintedNotification,
  ActivityUsedNotification
} from './components'
import { isFavoritedNotification, isMintedNotification, isUsedNotification } from './types'

interface Props {
  notification: NotificationModel
}

export const ActivityNotification: FC<Props> = ({ notification }) => {
  if (isFavoritedNotification(notification)) {
    return <ActivityFavoritedNotification notification={notification} />
  }

  if (isUsedNotification(notification)) {
    return <ActivityUsedNotification notification={notification} />
  }

  if (isMintedNotification(notification)) {
    return <ActivityMintedNotification notification={notification} />
  }

  console.warn(
    `Unknown type passed to ActivityNotification: ${notification.id} - ${notification.data.type}`
  )

  return null
}
